import {AOperation} from "../../../models/operations/AOperation";
import axios from "axios";
import {API_URL_OPERATION} from "./Utils";
import AuthenticationLocalService from "../localStorage/AuthenticationLocalService";
import {EOperationType} from "../../../models/utils/EOperationType";
import {InstallationEquipment} from "../../../models/operations/InstallationEquipment";
import {AElement} from "../../../models/elements/AElement";
import {EElementType} from "../../../models/utils/EElementType";
import {EnergyBox} from "../../../models/elements/EnergyBox";
import {InstallationElement} from "../../../models/operations/InstallationElement";
import {UninstallElement} from "../../../models/operations/UninstallElement";
import {ReplaceElement} from "../../../models/operations/ReplaceElement";
import {Geolocate} from "../../../models/operations/Geolocate";

class OperationDistantService {

    public createOperation(operation: AOperation) {
        return axios.post(API_URL_OPERATION, {
            type: operationTypesAPI[operation.type],
            date: operation.date,
            code_intervention: operation.idUser,
            location: {
                lat: operation.geolocation?.latitude,
                long: operation.geolocation?.longitude
            },
            comment: operation.commentary,
            data: this.getOperationData(operation)
        }, {
            headers: AuthenticationLocalService.authHeader()
        });
    }

    private getOperationData(operation: AOperation): object {
        let data = {};
        switch (operation.type) {
            case EOperationType.InstallationEquipment:
                let installationEquipment = operation as InstallationEquipment;
                data = {
                    type: equipmentTypesAPI[installationEquipment.equipment!.type],
                    components: this.getComponentsData(installationEquipment.equipment!.elements)
                };
                break;
            case EOperationType.InstallationElement:
                let installationElement = operation as InstallationElement;
                data = {
                    equipment_id: installationElement.equipmentId,
                    new_component: this.getElementData(installationElement.newElement!)
                };
                break;
            case EOperationType.UninstallationEquipment:
                break;
            case EOperationType.UninstallationElement:
                let uninstallationElement = operation as UninstallElement;
                data = {
                    equipment_id: uninstallationElement.equipmentId,
                    old_component: this.getElementData(uninstallationElement.oldElement!)
                };
                break;
            case EOperationType.ReplacementElement:
                let replacementElement = operation as ReplaceElement;
                data = {
                    equipment_id: replacementElement.equipmentId,
                    new_component: this.getElementData(replacementElement.newElement!),
                    old_component: this.getElementData(replacementElement.oldElement!)
                };
                break;
            case EOperationType.Geolocate:
                let geolocate = operation as Geolocate;
                data = {
                    component: {
                        type: "OTHER",
                        serial_nb: geolocate.equipmentId
                    }
                };
                break;
            default:
                // Nothing to do
                break;
        }
        return data;
    }

    private getComponentsData(elements: AElement[]): object[] {
        let data = [];
        for(let i = 0; i < elements.length; i++) {
            data.push(this.getElementData(elements[i]));
        }
        return data;
    }

    private getElementData(element: AElement): object {
        let data = {};
        switch (element.type) {
            case EElementType.EnergyBox:
                let elementCast = element as EnergyBox;
                data = {
                    is_scanned: elementCast.isScanned,
                    lora_eui: elementCast.eLoraId,
                    serial_nb: elementCast.serialNumber,
                    type: elementTypesAPI[elementCast.type]
                }
                break;
            default:
                data = {
                    is_scanned: element.isScanned,
                    serial_nb: element.serialNumber,
                    type: elementTypesAPI[element.type]
                }
                break;
        }
        return data;
    }

}

export default new OperationDistantService();

const operationTypesAPI = [
    "INSTALL",
    "ADD",
    "",
    "REMOVE",
    "REPLACE",
    "GEOLOCATE"
];

const equipmentTypesAPI = [
    "STREETLIGHT",
    "GATEWAY"
];

const elementTypesAPI = [
    "ENERGY_BOX",
    "GATEWAY",
    "MAST",
    "SOLAR_PANEL",
    "OTHER"
];
